const VIEW_AS_KEY = "viewAsUser";

// Only this admin account gets the read-only "View as" feature
export const IMPERSONATOR_EMAIL = "admin@example.com";

export function canImpersonate(authUser) {
  return (
    !!authUser &&
    authUser.role === "admin" &&
    authUser.email === IMPERSONATOR_EMAIL
  );
}

export function getViewAsUser() {
  try {
    return JSON.parse(localStorage.getItem(VIEW_AS_KEY));
  } catch (e) {
    return null;
  }
}

export function isViewAsActive(authUser) {
  return canImpersonate(authUser) && !!getViewAsUser();
}

export function startViewAs(targetUser) {
  localStorage.setItem(
    VIEW_AS_KEY,
    JSON.stringify({
      id: targetUser.id || targetUser._id,
      name: targetUser.name,
      email: targetUser.email,
    })
  );
}

export function stopViewAs() {
  localStorage.removeItem(VIEW_AS_KEY);
}
